<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon nzBack nzTitle="Token" nzSubtitle=" - Lançamento de tokens.">
    </nz-page-header>

    <form nz-form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Parceiro:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select name="tokenable_id" formControlName="tokenable_id" nzShowSearch nzPlaceHolder="Seleciona o Parceiro">
                            <nz-option *ngFor="let option of parceiros" [nzLabel]="option.label" [nzValue]="option.value">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Nome:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="name" maxlength="45" formControlName="name" placeholder="Nome do Programa" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired>Habilidades:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select nzMode="multiple" name="abilities" formControlName="abilities" nzShowSearch nzPlaceHolder="Seleciona as Habilidades">
                            <nz-option *ngFor="let option of habilidades" [nzLabel]="option.label" [nzValue]="option.value">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="idToken" nzBlock>Atualizar</button>
                <button nz-button nzType="primary" *ngIf="!idToken" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>